<template>
  <div class="table-collapse">
    <div
      class="table-collapse__head"
      :class="{ 'brand-100': isBodyShow }"
      @click="isBodyShow = !isBodyShow"
    >
      <slot name="head" :isBodyShow="isBodyShow">head</slot>
    </div>
    <div class="table-collapse__body">
      <slot name="body" v-if="isBodyShow">body</slot>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    isBodyShow: false,
  }),
};
</script>

<style lang="scss" scoped>
.table-collapse {
  &__head {
    cursor: pointer;
    transition: all 0.5s;
    &:hover {
      background-color: #e8efff;
    }
  }
}
</style>
